"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DetailsHeader;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _r10SourceLibrary = require("r10-source-library");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HeaderWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // Override Block styles\n  div:nth-child(1) {\n    max-width: 100%;\n  }\n"])));
var FlexDiv = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var FlexItem = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
function DetailsHeader(_ref) {
  var title = _ref.title;
  var history = (0, _reactRouterDom.useHistory)();
  var _useConfig = (0, _useConfig2.default)(),
    _useConfig$widgetCust = _useConfig.widgetCustomization,
    _useConfig$widgetCust2 = _useConfig$widgetCust === void 0 ? {} : _useConfig$widgetCust,
    backBtnRedirectionUrl = _useConfig$widgetCust2.backBtnRedirectionUrl;
  var redirect = function redirect() {
    history.push(backBtnRedirectionUrl);
  };
  return /*#__PURE__*/_react.default.createElement(HeaderWrapper, {
    "data-testid": "pega-details-header"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Block, null, /*#__PURE__*/_react.default.createElement(FlexDiv, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Interaction, {
    onClick: redirect,
    dataAttributes: {
      'data-testid': 'pega-details-header-go-back-arrow'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "arrow-left",
    group: "system",
    size: 4
  })), title && /*#__PURE__*/_react.default.createElement(FlexItem, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-details-title"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 3,
    weight: 2,
    justify: "center",
    text: title
  }))))));
}
DetailsHeader.propTypes = {
  title: _propTypes.default.string
};